import React from 'react';
import './icon-components.css';
import CheckMarkIcon from "../../assets/custom-icons/CheckMarkIcon";

export const CheckmarkCircle = () => {
    return (
        <div className="checkmark-circle">
            <CheckMarkIcon size={40} color={'white'} className="checkmark-icon" />
        </div>
    );
};
